import { render } from "./NotificationsMenu.vue?vue&type=template&id=37c9451e&scoped=true&ts=true"
import script from "./NotificationsMenu.vue?vue&type=script&lang=ts"
export * from "./NotificationsMenu.vue?vue&type=script&lang=ts"

import "./NotificationsMenu.vue?vue&type=style&index=0&id=37c9451e&scoped=true&lang=css"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c9451e"]])

export default __exports__